import type { DownloadFile } from "@/domain/types";
import { blobDownload } from "@/platform/lib/blob-download";
import { DownloadButton } from "./DownloadButton";

/**
 * Download a simple Game Profile's source file (Destiny's cvars.xml), served as a client Blob from
 * the in-bundle text. Shown for a built-in Profile that carries a `download`; SC2 uses the Preset
 * catalog path (PresetDownload) instead, and an uploaded Profile carries no source, so the caller
 * renders nothing. The format chip names the artifact, read from the download's own filename so it
 * tracks the real save name.
 */
export function ProfileDownload({ download }: { download: DownloadFile }) {
  // the literal artifact name: the last two dot-segments, no leading dot (so both today's
  // "Destiny2_default.cvars.xml" and a future bare "cvars.xml" read "cvars.xml"). Destiny's file has
  // one true name, unlike SC2's per-preset names where only the extension is shared.
  const format = download.fileName.split(".").slice(-2).join(".");
  return (
    <DownloadButton
      format={format}
      onClick={() => blobDownload(download.fileName, download.text)}
    />
  );
}
